import { render, staticRenderFns } from "./EditServiceTicket.vue?vue&type=template&id=246f2aec&"
import script from "./EditServiceTicket.vue?vue&type=script&lang=js&"
export * from "./EditServiceTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports